module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_unify_information-small-6bfda23f4c33df8c5b31b10755325a37.png";